import { useTranslation } from "react-i18next";
import { Button, Dialog, DialogContent, DialogFooter } from "ui";

import { SectionEditLoader } from "src/components/SectionEditLoader";

interface SectionDialogEditProps {
  sectionId: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  extraAction?: React.ReactNode;
  disabled?: boolean;
}

export function SectionDialogEdit(props: SectionDialogEditProps) {
  const { t } = useTranslation();

  return (
    <Dialog open={props.open} onOpenChange={props.onOpenChange}>
      <DialogContent className="flex h-[90vh] max-h-[90vh] flex-col gap-0 p-0 sm:max-w-5xl">
        <SectionEditLoader
          workoutId={props.sectionId}
          disabled={props.disabled}
        />
        <DialogFooter className="border-t px-4 py-3">
          <Button variant="outline" onClick={() => props.onOpenChange(false)}>
            {t("editWorkout.importSection.close")}
          </Button>
          {props.extraAction}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
